const resource = 'vehicle_types'

export default $axios => ({
  fetch(params) {
    return $axios.$get(`/${resource}`, { params })
  },
  get(id, params) {
    return $axios.$get(`/${resource}/${id}`, { params })
  },
  fetchVehicleSearchTypes() {
    return $axios.$get('/v2/vehicle-search/types')
  },

  getServiceName: name => 'vehicleTypeService',
})
